import React from "react";
import { Container, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Facebook, Twitter } from 'react-bootstrap-icons';
import { Menu, Space, Button } from 'antd';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Footer = function Footer() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "first-footer-section",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 4,
            children: /*#__PURE__*/_jsxs("div", {
              className: "footer-box",
              children: [/*#__PURE__*/_jsx("h4", {
                children: "Qui sommes-nous ?"
              }), /*#__PURE__*/_jsxs("p", {
                children: [/*#__PURE__*/_jsx("b", {
                  children: "Baramoo"
                }), " est la premi\xE8re plateforme qui aide \xE0 connecter les entrepreneurs aux opportunit\xE9s."]
              })]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 3,
            md: 3,
            sm: 4,
            children: [/*#__PURE__*/_jsx("h4", {
              children: "Liens utiles"
            }), /*#__PURE__*/_jsx(Link, {
              to: "/cgu",
              children: "Conditions g\xE9n\xE9rales d'utilisation"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
              to: "/partenaires",
              children: "Nos partenaires"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Link, {
              to: "/about",
              children: "A propos"
            }), /*#__PURE__*/_jsx("br", {})]
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 4,
            children: /*#__PURE__*/_jsxs("div", {
              className: "footer-box",
              children: [/*#__PURE__*/_jsx("h4", {
                children: "Nos r\xE9seaux sociaux"
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "vertical",
                children: [/*#__PURE__*/_jsx(Button, {
                  href: "https://facebook.com/baramoonetwork",
                  target: "_blank",
                  type: "default",
                  icon: /*#__PURE__*/_jsx(Facebook, {}),
                  children: " Page Facebook"
                }), /*#__PURE__*/_jsx(Button, {
                  href: "https://twitter.com/baramoonetwork",
                  target: "_blank",
                  type: "default",
                  icon: /*#__PURE__*/_jsx(Twitter, {}),
                  children: " Page Twitter"
                })]
              })]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            sm: 4,
            children: /*#__PURE__*/_jsxs("div", {
              className: "footer-box",
              children: [/*#__PURE__*/_jsx("h4", {
                children: "Nos services ?"
              }), /*#__PURE__*/_jsxs("ul", {
                children: [/*#__PURE__*/_jsx("li", {
                  children: /*#__PURE__*/_jsx("a", {
                    href: "https://guisoftlab.com/web-development/",
                    target: "_blank",
                    children: "Agence creative"
                  })
                }), /*#__PURE__*/_jsx("li", {
                  children: /*#__PURE__*/_jsx("a", {
                    href: "#",
                    children: "Publicit\xE9"
                  })
                })]
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "second-footer-section",
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {})
        })
      })
    })]
  });
};
export default Footer;